import PricingSummary from '~/components/common/PricingSummary.vue';
import planFeatures from '~/assets/data/plan-features.json';
export default {
  name: 'PricingSection',
  components: {
    PricingSummary
  },
  props: {
    title: String,
    continueButtonTitle: String,
    continueButtonAction: Function,
    allPlans: {
      type: Array,
      required: true
    },
    selectedPlan: {
      type: Number,
      default: -1
    },
    memberProfile: {
      type: Object
    },
    isPlanStage: {
      type: Boolean,
      default: false
    },
    billingCycle: {
      type: Number,
      default: -1
    },
    pickMandatory: {
      type: Boolean,
      default: true
    },
    showFeatures: {
      type: Boolean,
      default: true
    },
    showPricingSummary: {
      type: Boolean,
      default: false
    },
    footer: String,
    wrapSlot: Boolean
  },
  data() {
    return {
      planFeatures,
      defaultPlanIndex: 1
    };
  },
  computed: {
    plans() {
      return this.allPlans.filter(p => !p.hidden);
    },
    cycleSelected() {
      return this.billingCycle > -1;
    },
    selected() {
      return this.selectedPlan > -1 || !this.pickMandatory;
    },
    savings() {
      return this.plans.map(plan => plan.price.map((price, index) => {
        const savings = plan.displayOnlyFullPrice[index] - price;
        return savings > 0 ? savings : null;
      }));
    },
    maxAnnualSavings() {
      const annualSavings = this.savings.map(plan => plan[1]).filter(Boolean);
      return Math.max(...annualSavings);
    }
  },
  methods: {
    selectBillingCycle(index) {
      this.$emit('update:billingCycle', index);
    },
    selectPlan(index) {
      const i = this.selectedPlan === index ? -1 : index;
      this.$emit('update:selectedPlan', i);
    }
  }
};